(function () {
  'use strict';

  var STORAGE_KEY = 'pbs_claimed_offer';
  var CLAIM_MAX_AGE_MS = 24 * 60 * 60 * 1000; // stop showing the discounted price after 24h even if not checked out

  function getClaimedOffer() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.percent || !data.ts) return null;
      if (Date.now() - data.ts > CLAIM_MAX_AGE_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function setClaimedOffer(code, percent) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ code: code, percent: percent, ts: Date.now() }));
    } catch (e) {
      // sessionStorage unavailable (private mode etc.) — redirect still applies the discount at checkout,
      // it just won't show the strikethrough price on later page views.
    }
  }

  // ---- 1. Wire up "Claim My Offer" buttons ----
  function initClaimButtons() {
    var buttons = document.querySelectorAll('[data-claim-offer]');
    buttons.forEach(function (btn) {
      if (btn.dataset.claimWired) return;
      btn.dataset.claimWired = 'true';
      btn.addEventListener('click', function (event) {
        var code = btn.dataset.discountCode || (window.PBS_OFFER_CONFIG && window.PBS_OFFER_CONFIG.code);
        var percent = parseFloat(btn.dataset.discountPercent) || (window.PBS_OFFER_CONFIG && window.PBS_OFFER_CONFIG.percent) || 0;
        var redirect = window.location.pathname + window.location.search;

        if (!code) return; // no discount configured, let the link behave normally

        event.preventDefault();
        setClaimedOffer(code, percent);
        // Shopify's native discount-apply URL: applies the code to the customer's checkout
        // session and redirects them to the given path.
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
      });
    });
  }

  // ---- 2. Rewrite prices on the page if an offer was claimed this session ----
  function parsePrice(text) {
    var match = text.match(/([^\d]*)([\d.,]+)/);
    if (!match) return null;
    var prefix = match[1].trim();
    var numStr = match[2].replace(/,/g, '');
    var value = parseFloat(numStr);
    if (isNaN(value)) return null;
    var decimals = (numStr.split('.')[1] || '').length;
    return { prefix: match[1], value: value, decimals: decimals || 2 };
  }

  function formatPrice(prefix, value, decimals) {
    return prefix + value.toFixed(decimals);
  }

  function applyDiscountToPriceBlock(priceEl, percent) {
    if (priceEl.dataset.pbsDiscounted) return; // already processed

    // Standard Dawn-style structure: .price__regular .price-item--regular
    var regularEl = priceEl.querySelector('.price-item--regular') || priceEl.querySelector('.price__regular');
    // Skip if this price already shows a sale price (don't double-discount)
    if (priceEl.querySelector('.price-item--sale')) return;

    var targetEl = regularEl || priceEl;
    var parsed = parsePrice(targetEl.textContent);
    if (!parsed) return;

    var discounted = parsed.value * (1 - percent / 100);
    var originalText = formatPrice(parsed.prefix, parsed.value, parsed.decimals);
    var discountedText = formatPrice(parsed.prefix, discounted, parsed.decimals);

    // Build a sale-style markup re-using the theme's own price classes so existing
    // strikethrough/sale-color CSS applies automatically.
    var wrap = document.createElement('span');
    wrap.className = 'price__sale pbs-discounted-price';

    var oldPriceSpan = document.createElement('span');
    oldPriceSpan.className = 'price-item price-item--regular';
    var strike = document.createElement('s');
    strike.textContent = originalText;
    oldPriceSpan.appendChild(strike);

    var newPriceSpan = document.createElement('span');
    newPriceSpan.className = 'price-item price-item--sale';
    newPriceSpan.textContent = discountedText;

    wrap.appendChild(oldPriceSpan);
    wrap.appendChild(document.createTextNode(' '));
    wrap.appendChild(newPriceSpan);

    targetEl.replaceWith(wrap);
    priceEl.dataset.pbsDiscounted = 'true';
  }

  function applyDiscountToBundleH2(h2, percent) {
    if (h2.dataset.pbsDiscounted) return;
    if (h2.querySelector('del')) return; // bundle already has its own sale price — don't double-discount

    var text = h2.textContent.trim();
    var parsed = parsePrice(text);
    if (!parsed) return;

    var discounted = parsed.value * (1 - percent / 100);
    var originalText = formatPrice(parsed.prefix, parsed.value, parsed.decimals);
    var discountedText = formatPrice(parsed.prefix, discounted, parsed.decimals);

    h2.innerHTML = discountedText + '<br><span> <del>' + originalText + '</del></span>';
    h2.dataset.pbsDiscounted = 'true';
  }

  function applyDiscountedPricesOnPage() {
    var offer = getClaimedOffer();
    if (!offer) return;

    // Standard Dawn-style price blocks (other pages/themes)
    document.querySelectorAll('.price').forEach(function (el) {
      if (el.closest('.upsell_main_container')) return; // handled separately below
      applyDiscountToPriceBlock(el, offer.percent);
    });

    // This store's bundle-picker app price blocks
    document.querySelectorAll('.single_product .product_area h2').forEach(function (h2) {
      applyDiscountToBundleH2(h2, offer.percent);
    });
  }

  function init() {
    initClaimButtons();
    applyDiscountedPricesOnPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on dynamic content changes common in Shopify themes (quick view, ajax cart, variant swap)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', init);

  // Safety net: the bundle-picker app may inject its price widget asynchronously
  // after initial page load, so watch for new nodes and re-apply if needed.
  var pendingRun = null;
  var observer = new MutationObserver(function () {
    if (pendingRun) return;
    pendingRun = setTimeout(function () {
      pendingRun = null;
      applyDiscountedPricesOnPage();
    }, 300);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();